export default "__VITE_ASSET__Treag1jg__"